var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1075 1.84625C6.11263 1.85086 6.11766 1.85562 6.12259 1.86056L7.55565 3.29531C7.65328 3.39305 7.81157 3.39305 7.9092 3.29531C8.00683 3.19756 8.00683 3.03908 7.9092 2.94134L6.47614 1.50658C6.13443 1.16447 5.58041 1.16447 5.2387 1.50658L3.80565 2.94134C3.70801 3.03908 3.70801 3.19756 3.80565 3.29531C3.90328 3.39305 4.06157 3.39305 4.1592 3.29531L5.59226 1.86056C5.59724 1.85557 5.60232 1.85076 5.6075 1.84611L5.6075 8.4997C5.6075 8.63794 5.71943 8.75 5.8575 8.75C5.99557 8.75 6.1075 8.63794 6.1075 8.4997L6.1075 1.84625Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscIcon);
export default __webpack_public_path__ + "static/media/AscIcon.44e529aad3799463528165e700a81277.svg";
export { ForwardRef as ReactComponent };